import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ClientAuthProvider } from './context/ClientAuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { LoadingProvider } from './context/LoadingContext';
import GlobalLoadingIndicator from './components/common/GlobalLoadingIndicator';
import { installGlobalI18n } from './utils/i18nGlobal';
import { installPacificTime } from './utils/pacificTime';
import { installUploadsFallback } from './utils/uploadsFallback';
import { loadTheme, applyTheme, syncRemoteTheme } from './utils/theme';
import './styles/index.css';
import './styles/admin-mobile.css';
// Staff backend Luxe theme — every rule is scoped under .staff-luxe (DashboardLayout).
import './styles/staff-luxe.css';

// Every rendered timestamp reads in 美西时间 (US Pacific), whatever timezone the
// viewer's machine is set to. Must run before anything formats a date.
installPacificTime();

// 香港站: a just-uploaded image not synced to HK yet is loaded from the US site.
installUploadsFallback();

// Auto-translate toast / alert / confirm / prompt to Chinese when language=zh.
installGlobalI18n();

// Apply the cached theme instantly, then sync the GLOBAL admin theme from the
// server so every user/device follows the admin's settings.
applyTheme(loadTheme());
syncRemoteTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <LanguageProvider>
        <LoadingProvider>
          <AuthProvider>
            <ClientAuthProvider>
            <GlobalLoadingIndicator />
            <App />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
              // Always render above every modal / overlay in the app so toast
              // messages are never hidden behind a dialog.
              style={{ zIndex: 2147483647 }}
            />
          </ClientAuthProvider>
          </AuthProvider>
        </LoadingProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);
